import React from 'react'
import { buildPropTypes, pt } from 'common-data/proptypehelpers'
import _ from 'common-tools/LodashHelper'
import { reduxForm, submit } from 'redux-form'
import { Row, Col, Form } from 'reactstrap'
import { Button } from './Button'
import SectionComponent from 'common-classes/SectionComponent'
import styles from './FormBox.less'

export const FormBoxHeader = ({ title, children, hide = false, show = true, subLevel }) => {
  if (hide === true) {
    return null
  }
  if (show === false) {
    return null
  }
  return <Row>
    <Col md={12} className={styles.formBoxHeader}>
      {subLevel === true
        ? <h3>{title}</h3>
        : <h2>{title}</h2>
      }
      {children}
    </Col>
  </Row>
}

export const FormBoxContext = React.createContext(
  {
    loading: false,
    readonly: false
  }
)

class FormBoxPlain extends SectionComponent {
  static propTypes = buildPropTypes([

  ], {
    onSubmit: pt.func.isRequired,
    onChange: pt.func,
    onFormUnmount: pt.func,
    showButtons: pt.bool.isRequired,
    buttonSetup: pt.shape({
      submitText: pt.string,
      submitColor: pt.string,
      cancelText: pt.string,
      cancelColor: pt.string,
      showCancel: pt.bool
    }),
    destroyOnUnmount: pt.bool.isRequired,
    form: pt.string.isRequired,
    children: pt.node,
    dispatch: pt.func.isRequired,
    onCancel: pt.func,
    handleSubmit: pt.func,
    className: pt.string,
    loading: pt.bool,
    readonly: pt.bool,
    hideLoadingImage: pt.bool.isRequired,
    simpleBody: pt.bool.isRequired
  })

  static defaultProps = {
    showButtons: false,
    buttonSetup: {
      submitText: 'Save',
      submitColor: 'primary',
      cancelText: 'Cancel',
      cancelColor: 'secondary',
      showCancel: false
    },
    destroyOnUnmount: true,
    hideLoadingImage: false,
    readonly: false,
    simpleBody: false
  }

  onClick = () => {
    const { dispatch, form } = this.props
    dispatch(submit(form))
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onFormUnmount = (c) => {
    if (!c) {
      const { onFormUnmount } = this.props
      if (_.isFunction(onFormUnmount)) {
        onFormUnmount()
      }
    }
  }

  renderAdvancedBody (buttonSetup, showButtons, loading) {
    const formBody = this.getChild(0)
    const formButtons = this.getChild(1, { submitClick: this.onClick, cancelClick: this.onCancel }, false)

    return (
      <React.Fragment>
        {formBody}
        {showButtons
          ? formButtons ||
          <Row>
            <Col>
              <Button color={buttonSetup.submitColor} loading={loading} onClick={this.onClick} type='submit'>{buttonSetup.submitText}</Button>{' '}

              {buttonSetup.cancelText
                ? <Button color={buttonSetup.cancelColor} disabled={loading} onClick={this.onCancel}>{buttonSetup.cancelText}</Button> : null}
            </Col>
          </Row>
          : null
        }
      </React.Fragment>
    )
  }

  render () {
    const { handleSubmit, onSubmit, loading, buttonSetup, showButtons, className, simpleBody, children, readonly } = this.props
    return (
      <React.Fragment>
        <FormBoxContext.Provider value={{ loading: loading, readonly: readonly }}>
          <Form className={className} onSubmit={handleSubmit(onSubmit)}>
            {simpleBody === true
              ? children
              : this.renderAdvancedBody(buttonSetup, showButtons, loading)
            }
          </Form>
        </FormBoxContext.Provider>
        <span ref={this.onFormUnmount} />
      </React.Fragment>
    )
  }
};

export const FormBox = reduxForm({
  enableReinitialize: true
})(FormBoxPlain)
